import { Modal, Result, Button } from 'antd';
import DeleteIcon from '@mui/icons-material/Delete';

const ConfirmDeleteDraftModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    draftName, 
    statusTokens 
}) => {
    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            centered
            footer={null}
        >
            <Result
                icon={<DeleteIcon style={{ color: statusTokens.error, fontSize: 64 }} />}
                title="Delete Draft Catalogue"
                subTitle={`Are you sure you want to delete the draft "${draftName || 'Untitled'}"? This action cannot be undone.`}
                extra={[
                    <Button 
                        key="delete" 
                        danger 
                        type="primary" 
                        onClick={onConfirm}
                    >
                        Delete
                    </Button>,
                    <Button 
                        key="cancel" 
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                ]}
            />
        </Modal>
    );
};

export default ConfirmDeleteDraftModal;
